var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain02Hill1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 3534.7,
    height: 5102.84,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3534.7 5102.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:url(#d);}.f{fill:url(#c);}.g{fill:#347a65;}.h{fill:#4d9b69;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 464.85,
    y1: 3146.58,
    x2: 465.01,
    y2: 12362.78,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#317664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61b76c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 2109.32,
    y1: 4174.91,
    x2: 5567.35,
    y2: 7192.49,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57a96a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3530.99,3141.64c-658.1-301.9-982.9-176.5-1297.6,4.5-144,82.9-829.7,670.39-2233.39,1019.42l5.72,937.28,3525.27-13.35v-1947.84Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3530.99,3141.64c-244.3-112-442.6-165.1-611.5-178.5-66.2,3.7-128.6,15.2-155.8,42.4,0,0-63.8,58,105.3,105.2,169.2,47.4,35.1,245.7,350.9,315.9,146,32.5,201,103.3,247.6,168.1h63.4v-453.1h.1Z",
    style: {
      fill: "#347a65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3530.99,3284.64c-121,38.2-252.9,58.9-389.4,66.1-338.9,17.9-707-47.4-1012.8-135.5l-11,7.7c308.5,89.6,681.2,156.4,1024.4,138.3,136.3-7.2,267.8-27.8,388.9-65.5v-11.1h-.1Zm0-143v8.6c-91.1,20.4-186.8,32.6-284.9,37.7-297.6,15.7-617.6-32.4-898.4-103.9,4.8-2.4,9.6-4.8,14.4-7.1,277.1,69.6,591.1,116,883.5,100.6,97.2-5.1,192.1-17.1,282.3-37.3l3.1,1.4Zm0,71.5v10.9c-106.4,28.3-219.9,44.4-336.9,50.5-323.2,17-672.8-41.2-970-123,3.1-1.9,6.3-3.7,9.3-5.5l3.3-1.9c294.1,80,638.3,136.6,956.8,119.8,117.3-6.1,231.1-22.2,337.5-50.8Zm0,140.4v11.1c-135,49.1-284.9,74.9-440.8,83-362.2,19.1-757.4-56.3-1075-153.3,3.7-2.6,7.4-5.1,11.1-7.6,315.3,95.6,705.5,169.3,1063.3,150.5,156.4-8.3,306.5-34.2,441.4-83.7Zm0,65.9v11.4c-148,62.5-316.5,94.1-492.8,103.4-383.3,20.1-803.8-65.5-1130-170.6,3.9-2.4,7.8-4.8,11.7-7.3,324.1,103.7,739.1,187.4,1117.7,167.4,176.8-9.3,345.6-41.2,493.4-104.3Zm0,62.7v11.7c-96.9,47.4-204,80.1-317.1,100.9h-65.4c137.6-19.5,267.4-55.6,382.5-112.6Zm0,64.8v12.1c-22.4,12.7-45.4,24.7-69,35.7h-25.5c32.7-14.3,64.2-30.2,94.5-47.8Zm-968.9,47.8h-82.5c-247.3-34.8-486.7-97.1-685.2-165.1,4.2-2.3,8.3-4.5,12.4-6.8,217.9,73.9,484.1,140.7,755.3,171.9Zm-493.2,0h-40.6c-123.1-33.4-238.4-71.2-340.6-109.9,4.3-2.1,8.7-4.2,12.9-6.3,110.1,41.3,235.1,81.5,368.3,116.2Zm1346.7-503.1c-6.9-2.8-13.8-5.6-20.6-8.3-32.1,3.3-64.7,5.9-97.5,7.6-258.3,13.6-533.5-21-785.2-77.3-6.2,2.1-12.4,4.3-18.5,6.6,256.9,58.6,539.4,95.1,804.3,81.2,39.5-2.1,78.8-5.4,117.5-9.8Zm-210.9-74.1c-13.8-3.9-27.4-7.8-40.8-11.3-138.6-4.1-279.3-19.7-416.1-43-12.8,1.1-25.5,2.4-37.9,3.9,162.1,29.4,330.2,48.3,494.8,50.4Z",
    style: {
      fill: "#4d9b69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.29,3290.24c-50.6,34.5-108.4,71.9-176,110.9,237.7-50.1,450.1-61.1,659.5-38.2,259,28.3,745.03,166.3,1029.91,341.61l-4.38-92.04c-375.3-167.2-700.12-294.08-1017.12-328.68-159.7-17.5-320.6-16-491.9,6.4Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885.65,3695.04c-123.1-33.4-238.4-71.2-340.6-109.9",
    style: {
      fill: "#4d9b69"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain02Hill1);
export default __webpack_public_path__ + "static/media/mountain-02-hill-1.44a2d057f9ff296b6c8e97baec3cf8c4.svg";
export { ForwardRef as ReactComponent };